import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		padding: theme.spacing(0.5, 0.5, 2, 0.5),
		minHeight: 48,
		flexWrap: "wrap",
		[theme.breakpoints.down("sm")]: {
			alignItems: "stretch",
			flexDirection: "column",
			gap: theme.spacing(1.25),
			padding: theme.spacing(0, 0, 1.5),
			minHeight: 0,
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
